import React from "react";
import TextInput from "../../../../lib/components/TextInput";

export default function EctsInput({ title, onChange, value, placeholder }) {
  return (
    <section className="flex justify-between items-center space-x-2">
      <div className="font-serif">
        <h6 className="text-base font-bold tracking-tight">{title}</h6>
      </div>

      <div className="w-1/4">
        <TextInput
          value={value}
          type="number"
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
    </section>
  );
}
